import { getLetterName } from "../SideBar/getLetterName"
import { ButtonLess } from "../button/buttonLess"
import './ListNotasChildrens.css'

export const Table = ({ style, arr, type, onClick, className }) => {

    return (
        <section style={style} className={`body-list-notas_table_content ${className}`}>
            <table className="body-list-notas_table">
                <thead>
                    <tr>
                        <th style={{ width: '20%' }}>Nome</th>
                        <th style={{ width: '32%', backgroundColor: '#F3F3F3', color: type == 3 ? '' : '#F3F3F3' }}>E-Mail</th>
                        <th style={{ width: '20%' }}>Type</th>
                        <th style={{ width: '20%' }}>Site</th>
                        <th style={{ backgroundColor: '#F3F3F3', color: '#F3F3F3', position: 'sticky', right: 0, top: 0, zIndex: 10 }}>.</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        arr?.map((value, i) => (
                            <tr key={i} >
                                <td>{getLetterName(value.emailColab, 'email-long')}</td>
                                <td >
                                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                        <h1 style={{ width: 40, height: 40 }} className='side-bar-area_initials'>{getLetterName(value.emailColab, 'email')}</h1>
                                        <div>
                                            <h3>{value.emailColab}</h3>
                                        </div>
                                    </div>
                                </td>
                                <td>{value.Type}</td>
                                <td>{value.Site}</td>
                                <td>
                                    <div style={{ display: 'flex', gap: 10 }}>
                                        <ButtonLess onClick={() => onClick(value.idAccessControl)} type='remove' />
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </section >
    )
}